(function (scope, factory) {
  const api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else { scope.LensswitchConfigure = api; api.start(scope.document); }
})(typeof window === 'undefined' ? this : window, function () {
  'use strict';
  const shapeOrder = ['Avela','Liora','Arven','Vero','Oria','Sera','Rova','Norel','Elara'];
  const finishes = ['No Cut','Standard Cut','Diamond Cut'];
  const hiddenHandles = ['santos-ct0167o','premiere-ct0284o','panthere-ct0061o','piccadilly'];
  const canonicalFinish = value => String(value || '').split(' + ')[0].replace(/^Smooth Cut$/i,'Standard Cut').replace(/^Full Diamond Cut$/i,'Diamond Cut');
  const defaultShape = value => ({occi:'Avela',rexagon:'Liora',hexogan:'Arven',hexagon:'Arven',rectangle:'Vero',oval:'Oria',butterfly:'Sera',round:'Rova',cateye:'Norel',square:'Elara'}[String(value).toLowerCase()] || value);
  function safePath(value) {
    return typeof value === 'string' && /^\/(?!\/)/.test(value) && !/[\\\r\n]/.test(value) ? value : null;
  }
  async function loadCatalogue(base, fetcher=fetch) {
    if(!safePath(base)) throw new Error('Invalid collection URL');
    const products=[];
    let page=1,pages=1,total=0;
    do {
      const query=new URLSearchParams({view:'configure-data',page:String(page)});
      const response=await fetcher(base.split('?')[0]+'?'+query,{headers:{Accept:'text/html'}});
      if(!response.ok) throw new Error('Catalogue unavailable');
      const payload=await response.json();
      if(payload.page!==page||!Number.isInteger(payload.pages)||payload.pages<page||payload.pages>100||!Array.isArray(payload.products)) throw new Error('Incomplete pages');
      pages=payload.pages;total=payload.total;products.push(...payload.products);page++;
    } while(page<=pages);
    if(products.length!==total) throw new Error('Incomplete products');
    return products;
  }
  function createModel(products, helpers = {}) {
    const colour = value => String((helpers.colour || (v=>v))(value) || '');
    const shape = value => String((helpers.shape || defaultShape)(value) || '');
    const rows = [];
    for (const product of products) {
      if (hiddenHandles.includes(product.handle)) continue;
      const options = (product.options || []).map(v=>String(typeof v==='string'?v:v.name).toLowerCase());
      const colourIndex = options.findIndex(n=>['kleur','color','colour'].includes(n));
      const shapeIndex = options.findIndex(n=>['vorm','shape','glazen','glasses','lenses'].includes(n));
      const finishIndex = options.findIndex(n=>['afwerking','finish'].includes(n));
      if ([colourIndex,shapeIndex,finishIndex].includes(-1)) continue;
      if (!Array.isArray(product.variants) || !Number.isInteger(product.expectedVariants) || product.variants.length !== product.expectedVariants) throw new Error('Incomplete catalogue: '+product.handle);
      const url = safePath(product.url);
      if (!url) throw new Error('Invalid product URL');
      for (const variant of product.variants) {
        const [id,available,price,values,image] = variant;
        const rawFinish = String(values[finishIndex] || '');
        const finish = canonicalFinish(rawFinish);
        if (!finishes.includes(finish) || !Number.isSafeInteger(id) || !Number.isFinite(price)) continue;
        rows.push({id,available:available===true,price,shape:shape(values[shapeIndex]),colour:colour(values[colourIndex]),rawColour:values[colourIndex],finish,prescription:/Sterkte|Single vision/i.test(rawFinish),gold:/Gold Flash/i.test(rawFinish),handle:product.handle,url,image:image||null,productImage:product.image||null,initialColour:colour(product.initialColour),imageFinish:canonicalFinish(product.imageFinish)});
      }
    }
    const unique = values => [...new Set(values)];
    const available = rows.filter(r=>r.available);
    const shapes = () => unique(available.map(r=>r.shape)).sort((a,b)=>{
      const ai=shapeOrder.indexOf(a),bi=shapeOrder.indexOf(b);
      return (ai<0?999:ai)-(bi<0?999:bi)||a.localeCompare(b);
    });
    const colours = selected => {
      const values=unique(available.filter(r=>r.shape===shape(selected)).map(r=>r.colour));
      return helpers.compareColour ? values.sort(helpers.compareColour) : values;
    };
    const matches = (row,s) => row.shape===shape(s.shape)&&row.colour===colour(s.colour)&&row.finish===canonicalFinish(s.finish)&&row.prescription===!!s.prescription&&row.gold===!!s.gold;
    const resolve = selection => available.filter(row=>matches(row,selection)).sort((a,b)=>{
      const score=r=>(r.initialColour===r.colour?4:0)+(r.image?2:0);
      return score(b)-score(a);
    })[0] || null;
    const finishChoices = (s,c) => finishes.filter(f=>resolve({shape:s,colour:c,finish:f}));
    const next = selection => {
      if (!shapes().includes(shape(selection.shape))) return {step:'shape'};
      const s=shape(selection.shape);
      if (!colours(s).includes(colour(selection.colour))) return {step:'colour',shape:s};
      return {step:'finish',shape:s,colour:colour(selection.colour)};
    };
    const url = (base, selection={}) => {
      if (!safePath(base)) throw new Error('Invalid collection URL');
      const q=new URLSearchParams({view:({shape:'vormen',colour:'kleuren',finish:'afwerkingen'})[selection.step]||'vormen',configure:'1'});
      if (selection.shape) q.set('shape',shape(selection.shape));
      if (selection.colour && selection.step==='finish') q.set('colour',colour(selection.colour));
      if (selection.prescription) q.set('prescription','1');
      if (selection.gold) q.set('gold','1');
      return base.split('?')[0]+'?'+q;
    };
    const productUrl = row => { if (!row || !safePath(row.url)) return null; const q=new URLSearchParams({variant:String(row.id),configured:'1'}); return row.url.split('?')[0]+'?'+q; };
    return {rows,shapes,colours,finishes:finishChoices,resolve,next,url,productUrl};
  }
  function start(document) {
    if (!document) return;
    const run=()=>document.querySelectorAll('[data-ls-configure]').forEach(root=>{
      if (root.dataset.ready) return;
      root.dataset.ready='true';
      initialize(root).catch(error=>{console.warn('Lensswitch Configure:',error.message);showFailure(root);});
    });
    if (document.readyState==='loading') document.addEventListener('DOMContentLoaded',run,{once:true});
    else run();
  }
  function showFailure(root) {
    root.hidden=false;
    root.querySelector('[data-flow-status]').textContent=JSON.parse(root.querySelector('[data-flow-data]').textContent).text.error;
    root.querySelector('[data-flow-grid]')?.replaceChildren();
  }
  async function initialize(root) {
    const config=JSON.parse(root.querySelector('[data-flow-data]').textContent);
    const q=new URLSearchParams(location.search);
    const isProduct=!!config.product;
    if (!isProduct && q.get('configure')!=='1') return;
    root.hidden=false;
    if (!isProduct) {
      document.querySelector('#lensswitch-shop')?.classList.add('ls-configuring');
      document.querySelector('.ls-lens-nav a[data-configure-link]')?.setAttribute('aria-current','page');
      document.querySelectorAll('.ls-lens-nav a:not([data-configure-link])').forEach(a=>a.removeAttribute('aria-current'));
      document.querySelector('.ls-lens-nav__filter')?.removeAttribute('data-active');
    }
    const helpers={colour:v=>window.LensswitchLensColours.canonical(v),shape:v=>window.LensswitchModels.name(defaultShape(v)),compareColour:(a,b)=>(isProduct?window.LensswitchLensColours.compare:window.LensswitchLensColours.compareCollection)(a,b)};
    const products=await loadCatalogue(config.base);
    const model=createModel(products,helpers);
    root.querySelector('[data-flow-status]').textContent='';
    if (isProduct) return productAdapter(root,config,model,helpers);
    collectionAdapter(root,config,model,q);
  }
  function element(tag, text, className) {
    const node=document.createElement(tag);
    if (text!=null) node.textContent=text;
    if (className) node.className=className;
    return node;
  }
  function picture(source, label) {
    const img=element('img');img.src=source;img.alt=label;img.width=600;img.height=600;img.loading='lazy';return img;
  }
  function money(amount, language) { return new Intl.NumberFormat(language==='en'?'en-NL':'nl-NL',{style:'currency',currency:'EUR'}).format(amount/100); }
  function refreshVisualChoice(event, schedule, callback) {
    const target=event.target;
    if(target.tagName==='INPUT' && target.type==='radio' && ['color','finish'].includes(target.name)) schedule(callback);
  }
  function productSelection({panel,document,product,helpers,currentShape}) {
    const names=product.options.map(n=>n.toLowerCase());
    const index=values=>names.findIndex(n=>values.includes(n));
    const initialColour=product.selectedOptions[index(['kleur','color','colour'])];
    const initialFinish=product.selectedOptions[index(['afwerking','finish'])];
    const persistentType=document.querySelector('[data-lc-property="Type glazen"],[data-lc-property="Lens type"]')?.value;
    const persistentCoating=document.querySelector('[data-lc-property="Coating"]')?.value;
    const type=persistentType||document.querySelector('#lc-choices input[name="type"]:checked')?.value||(/Sterkte|Single vision/i.test(initialFinish)?'Single vision':'Fashion');
    const coating=persistentCoating||document.querySelector('#lc-choices input[name="coating"]:checked')?.value||(/Gold Flash/.test(initialFinish)?'Gold Flash':'Purple Flash');
    return {
      shape:currentShape,
      colour:helpers.colour(panel.querySelector('input[name="color"]:checked')?.value||initialColour),
      finish:canonicalFinish(panel.querySelector('input[name="finish"]:checked')?.value||initialFinish),
      prescription:/Enkelvoudig|Single vision/i.test(type),gold:/Gold Flash/i.test(coating)
    };
  }
  function photoFinish(source) {
    const path=String(source||'').split('?')[0].toLowerCase();
    if(/no[-_ ]?cut|lensswitch-finish-standard/.test(path)) return 'No Cut';
    if(/standard|smooth/.test(path)) return 'Standard Cut';
    if(/diamond/.test(path)) return 'Diamond Cut';
    return '';
  }
  function collectionAdapter(root,config,model,q) {
    const text=config.text;
    const selection={shape:q.get('shape'),colour:q.get('colour'),prescription:q.get('prescription')==='1',gold:q.get('gold')==='1'};
    const valid=model.next(selection);
    const view=q.get('view');
    const step=view==='vormen'?'shape':view==='kleuren'&&valid.shape?'colour':valid.step;
    const index=['shape','colour','finish'].indexOf(step);
    const heading=root.querySelector('[data-flow-title]');
    heading.textContent=text[step+'Title'];
    root.querySelector('[data-flow-counter]').textContent=text.step+' '+(index+1)+' '+text.of+' 3';
    root.querySelector('[data-flow-intro]').textContent=text[step+'Intro'];
    const steps=root.querySelector('[data-flow-steps]');
    ['shape','colour','finish'].forEach((key,i)=>{
      const li=element('li');
      const label=element(i<index?'a':'span',(i+1)+'. '+text[key]);
      if(i<index) label.href=model.url(config.base,{step:key,shape:valid.shape,prescription:selection.prescription,gold:selection.gold});
      if(i===index) label.setAttribute('aria-current','step');
      li.append(label);steps.append(li);
    });
    const summary=root.querySelector('[data-flow-summary]');
    if (valid.shape && step!=='shape') summary.append(element('span',text.shape+': '+valid.shape));
    if (valid.colour && step==='finish') summary.append(element('span',text.colour+': '+valid.colour));
    summary.hidden=!summary.children.length;
    const back=root.querySelector('[data-flow-back]');
    back.textContent=index===0?text.backAll:text.back;
    back.href=index===0?config.base:model.url(config.base,{step:index===2?'colour':'shape',shape:valid.shape,prescription:selection.prescription,gold:selection.gold});
    const grid=root.querySelector('[data-flow-grid]');
    let choices=[];
    if(step==='shape') choices=model.shapes();
    if(step==='colour') choices=model.colours(valid.shape);
    if(step==='finish') choices=finishes;
    choices.forEach(value=>{
      const selected={shape:valid.shape,colour:valid.colour,prescription:selection.prescription,gold:selection.gold};
      const row=step==='finish'?model.resolve({...selected,finish:value}):null;
      const link=element(step==='finish'&&!row?'div':'a',null,'ls-flow-card');
      if (link.tagName==='A') link.href=step==='shape'?model.url(config.base,{...selection,step:'colour',shape:value,colour:null}):step==='colour'?model.url(config.base,{...selected,step:'finish',colour:value}):model.productUrl(row);
      else link.classList.add('ls-flow-card--unavailable');
      const source=step==='shape'?config.images.shapes[value]:step==='colour'?window.LensswitchLensColours.image(value,600):config.images.finishes[value];
      if(source) link.append(picture(source,value));
      link.append(element('strong',value));
      if(step==='finish') link.append(element('span',row?money(row.price,config.language)+' · '+text.perSet:text.unavailable));
      if(step==='finish'&&row) link.append(element('span',text.viewProduct,'ls-flow-card__action'));
      grid.append(link);
    });
    if(!choices.length) root.querySelector('[data-flow-status]').textContent=text.noChoices;
    root.dataset.step=step;
  }
  function productAdapter(root,config,model,helpers) {
    const panel=document.querySelector('.lc-visual-panel');
    if(!panel) {root.hidden=true;return;}
    panel.prepend(root);
    const data=config.product;
    const names=data.options.map(n=>n.toLowerCase());
    const index=values=>names.findIndex(n=>values.includes(n));
    const currentShape=helpers.shape(data.selectedOptions[index(['vorm','shape','glazen','glasses','lenses'])]);
    const selected=()=>productSelection({panel,document,product:data,helpers,currentShape});
    const select=root.querySelector('[data-flow-shape]');
    model.shapes().forEach(shape=>{const option=element('option',shape);option.value=shape;option.selected=shape===currentShape;select.append(option);});
    const status=root.querySelector('[data-flow-status]');
    const alternative=root.querySelector('[data-flow-alternative]');
    select.addEventListener('change',()=>{
      const target=select.value,current=selected();
      if(target===currentShape) return;
      const row=model.resolve({...current,shape:target});
      if(row) {location.assign(model.productUrl(row));return;}
      select.value=currentShape;
      status.textContent=config.text.missingCombination.replace('[shape]',target);
      alternative.textContent=config.text.chooseColour.replace('[shape]',target);
      alternative.href=model.url(config.base,{step:'colour',shape:target,prescription:current.prescription,gold:current.gold});
      alternative.hidden=false;
    });
    const note=element('p',null,'ls-flow-photo-note');
    note.setAttribute('aria-live','polite');
    const gallery=document.querySelector('.lc-alternate-gallery');
    if(gallery) gallery.append(note);
    const updateNote=()=>{
      const current=selected();
      const row=model.resolve(current);
      const img=gallery?.querySelector('img');
      let sample=img?.classList.contains('lc-lens-colour-sample');
      if(sample&&row?.image&&img) {
        img.src=row.image;img.alt=currentShape+' — '+current.colour;img.classList.remove('lc-lens-colour-sample');sample=false;
      }
      const shown=photoFinish(img?.getAttribute('src'));
      note.hidden=!sample&&!!shown&&shown===current.finish;
      note.textContent=sample?config.text.sampleNote:shown?config.text.photoNote.replace('[finish]',shown).replace('[selected]',current.finish):config.text.genericPhotoNote.replace('[selected]',current.finish);
      status.textContent='';alternative.hidden=true;
    };
    panel.addEventListener('change',event=>refreshVisualChoice(event,requestAnimationFrame,updateNote));
    updateNote();
  }
  return {createModel,safePath,canonicalFinish,loadCatalogue,refreshVisualChoice,productSelection,photoFinish,start};
});
